import React, { useEffect, useRef, useState } from "react";
import Resource from "../../Assets/Images/pm-services-icon/resource.svg";
import Collab from "../../Assets/Images/pm-services-icon/collab.svg";
import PR from "../../Assets/Images/pm-services-icon/pr.svg";
import Success from "../../Assets/Images/pm-services-icon/success-manage.svg";
import AdaptChange from "../../Assets/Images/pm-services-icon/adapt.svg";
import Quality from "../../Assets/Images/pm-services-icon/quality.svg";
import "./Offering-service.css";

const OfferingProjectManagerServicePage = () => {
  const listOfServices = [
    {
      img: Resource,
      title: "We Start with What You Already Have",
      description:
        "Most projects begin in the midstream. We are reviewing existing systems, notes and frustrations so none of the important ones get ignored or rewritten unnecessarily.",
    },
    {
      img: Collab,
      title: "We Slow Down To Get It Right",
      description:
        "Before we actually build, we devote time for clearing up confusion and getting everyone on the same page in terms of priorities and what really matters so that time is saved later.",
    },
    {
      img: PR,
      title: "We Show Progress Early",
      description:
        "You get to see real, working features early on. That way, feedback becomes natural and corrections in the course are implemented before things go too far.",
    },
    {
      img: Success,
      title: "We Do Not Lose Flexibility in Losing Direction",
      description:
        "Plans change. And when they do, we adjust, calmly, protecting the already built rather than starting over or forcing bad decisions.",
    },
    {
      img: AdaptChange,
      title: "We Concentrate On What Works In Practice",
      description:
        "We judge progress based on what is actually running, performing, and helping users, not on documents or overly optimistic timelines.",
    },
    {
      img: Quality,
      title: "We Stick Around After Launch",
      description:
        "Launch is rarely the finish line. We stay close, fix things that are on the surface and help things to be more secure once the real users arrive.",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const rowRef = useRef(null);
  const progressRef = useRef(null);

  useEffect(() => {
    const row = rowRef.current;
    const progress = progressRef.current;
    if (!row || !progress || listOfServices.length === 0) return;

    // Update progress bar
    const percent = ((activeIndex + 1) / listOfServices.length) * 100;
    progress.style.transition = "width 0.4s ease";
    progress.style.width = `${percent}%`;

    if (window.innerWidth < 1024) {
      // Mobile: scroll to active card
      const activeCard = row.children[activeIndex];
      if (activeCard) {
        activeCard.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest",
        });
      }
    } else {
      // Desktop: calculate transform shift to prevent empty space at the end
      const cardWidth = row.children[0]?.offsetWidth + 30 || 0;
      const visibleCards = Math.floor(row.offsetWidth / cardWidth);
      const maxOffset = (listOfServices.length - visibleCards) * cardWidth;
      const rawOffset = (activeIndex - 1) * cardWidth;
      const offset = Math.max(0, Math.min(rawOffset, maxOffset));

      row.style.transition = "transform 0.5s ease";
      row.style.transform = `translateX(-${offset}px)`;
    }
  }, [activeIndex, listOfServices.length]);

  return (
    <div id="approach" className="offering-service-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="top-contents">
              <h1 className="service-headline1">
                How We Actually Run Projects Day To Day
              </h1>
            </div>

            <div className="middle-contents">
              <div className="carousel-wrapper">
                <div className="service-row" ref={rowRef}>
                  {listOfServices.map((service, i) => (
                    <div
                      key={i}
                      className={`service-card ${
                        i === activeIndex ? "active" : ""
                      }`}
                      onClick={() => setActiveIndex(i)}
                    >
                      <div className="service-icons">
                        <img src={service.img} alt={service.title} width={60} />
                      </div>
                      <h2 className="service-project-title">{service.title}</h2>
                      <p className="service-project-description">
                        {service.description}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="end-contents">
              <div className="progress-container">
                <div className="progress-bar" ref={progressRef}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfferingProjectManagerServicePage;
